export default "__VITE_ASSET__1o0MkgXP__"